import { Customer, Assistant, Workflow } from '../types';
import { apiClient } from './api';

export interface CreateUserRequest {
  name: string;
  email: string;
  password: string;
  role: 'user' | 'admin';
}

export const adminApi = {
  // Create new user
  createUser: async (userData: CreateUserRequest): Promise<Customer> => {
    return await apiClient.post<Customer>('/admin/users', userData);
  },
  
  // Get all users
  getAllUsers: async (): Promise<Customer[]> => {
    return await apiClient.get<Customer[]>('/admin/users');
  },

  // Get user's assistants
  getUserAssistants: async (userId: string): Promise<Assistant[]> => {
    return await apiClient.get<Assistant[]>(`/admin/users/${userId}/assistants`);
  },

  // Get user's workflows
  getUserWorkflows: async (userId: string): Promise<Workflow[]> => {
    return await apiClient.get<Workflow[]>(`/admin/users/${userId}/workflows`);
  },

  // Link assistant to user
  linkAssistantToUser: async (userId: string, assistantId: string): Promise<{ message: string; assistant: Assistant }> => {
    return await apiClient.post<{ message: string; assistant: Assistant }>(`/admin/users/${userId}/assistants/${assistantId}/link`);
  },

  // Link workflow to user
  linkWorkflowToUser: async (userId: string, workflowId: string): Promise<{ message: string; workflow: Workflow }> => {
    return await apiClient.post<{ message: string; workflow: Workflow }>(`/admin/users/${userId}/workflows/${workflowId}/link`);
  },

  // Unlink assistant from user
  unlinkAssistantFromUser: async (userId: string, assistantId: string): Promise<{ message: string }> => {
    return await apiClient.delete<{ message: string }>(`/admin/users/${userId}/assistants/${assistantId}/unlink`);
  },

  // Unlink workflow from user
  unlinkWorkflowFromUser: async (userId: string, workflowId: string): Promise<{ message: string }> => {
    return await apiClient.delete<{ message: string }>(`/admin/users/${userId}/workflows/${workflowId}/unlink`);
  },
};